import {
  BRANCH_LIST_REQUEST,
  BRANCH_LIST_SUCCESS,
  BRANCH_LIST_FAIL,
} from "../constant/BranchConstant";
import api from "../core/api";

export const getBranchList = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: BRANCH_LIST_REQUEST,
    });

    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };

    const { data } = await api.get(`/branch`, config);

    var dt = data.Result;
    if (dt.includes("Error")) {
      dispatch({
        type: BRANCH_LIST_FAIL,
        payload: dt,
      });
    } else {
      dispatch({
        type: BRANCH_LIST_SUCCESS,
        payload: dt,
      });
    }
  } catch (error) {
    dispatch({
      type: BRANCH_LIST_FAIL,
      payload:
        error.response && error.response.data
          ? error.response.data
          : error.message,
    });
  }
};

